import { useParams } from 'react-router-dom';
import styles from '../Home.module.scss';

export const About = ({ upPage, upContact }) => {
  const { lang } = useParams();
  const upAbout = upPage.acf.about;
  const { subtitle, title, text, items, content_bokey } = upAbout;
  const { address_link, address_text, phone, graphics } = upContact.acf;
  const upInfo = content_bokey;

  return (
    <section className={styles.about}>
      <div className="container">
        <div className={styles.about_body}>
          <div className={styles.about_row}>
            <div className={styles.about_info}>
              <h3 className={`${styles.about_info_subtitle} global-subtitle`}>{subtitle[lang]}</h3>
              <h2 className={`${styles.about_info_title} global-title`}>{title[lang]}</h2>
              <p className={`${styles.about_info_text} global-text`}>{text[lang]}</p>
              <div className={styles.about_info_row}>
                {items.map((el, idx) => {
                  const { numbers, text } = el;
                  return (
                    <div key={idx} className={styles.about_info_column}>
                      <div className={styles.about_info_column_body}>
                        <div className={styles.about_info_column_num}>{numbers}</div>
                        <p className={styles.about_info_column_text}>{text[lang]}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className={styles.about_contact}>
              <div className={styles.about_contact_icon}>{upInfo.icon}</div>
              <h2 className={styles.about_contact_title}>{upInfo.title[lang]}</h2>
              <a href={address_link} target="_black" className={styles.about_contact_address}>
                {address_text[lang]}
              </a>
              {phone.map((el, idx) => {
                const { text, link } = el;
                return (
                  <a key={idx} href={`tel:${link}`} className={styles.about_contact_phone}>
                    {text}
                  </a>
                );
              })}
              {graphics.map((el, idx) => {
                return (
                  <div key={idx} className={styles.about_contact_graphics}>
                    {el[lang]}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
